import React, { useState, useEffect } from "react";
// import axios from "axios";
import "../css/Accordion.css";

const Accordion = ({ data }) => {
  const [courseData, setCourseData] = useState([]);
  const [selectedMonthCourses, setSelectedMonthCourses] = useState([]);
  const [activeMonth, setActiveMonth] = useState(null);
  const [activeCourse, setActiveCourse] = useState(null);
  const [sessionType, setSessionType] = useState("standard");
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const fetchDataApi = async () => {
      setLoading(true)

      let payload = {
        level : data.level?.split(',')?.map(el => parseInt(el)),
        rank: data.rank,
        session_type: sessionType || data.type,
        lang: data.lang,
        currency: data.currency,
      }

      let URL = `${data.api}/get/courses/registration`;

      const response =  await fetch(URL, {
        method: 'post',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
      })

      if (!response.ok) {
        setLoading(false)
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      response.json().then(data => {
        let courses = data.courses
        setCourseData(courses);
        if (courses.length > 0) {
          setSelectedMonthCourses(courses[0].courses);
          setActiveMonth(0);
        }
        setLoading(false);
      });



    }
    fetchDataApi();


  }, [data, sessionType]);
  const handleMonthClick = (monthCourses, monthIdx) => {
    setSelectedMonthCourses(monthCourses);
    setActiveMonth(monthIdx);
    setActiveCourse(null);
  };

  const handleCourseClick = (courseId) => {
    setActiveCourse(courseId);
  };

  const handleSessionTypeChange = (type) => {
    setSessionType(type);
  };

  let index = 0
  let monthData = courseData[index]
  return (
    <div className="zx-tabs" id="promo_contents">
      {!loading && <>
        {courseData.length > 0 ? (
          // courseData.map((monthData, index) => (
            <div key={index} className="zx-tab">
              <input type="checkbox" id={`course-${index}`} />
              <label className="zx-tab-label" htmlFor={`course-${index}`} style={{  }}>
                {monthData.courses[0]?.master_course.name.en}
              </label>

              <div className="zx-tab-content">
                <>
                  <div className="zx-packs"></div>
                  <div className="zx-slider-nav">
                    <button
                      className={`standard-button ${
                        sessionType === "standard" ? "active-session" : ""
                      }`}
                      onClick={() => handleSessionTypeChange("standard")}
                    >
                      STANDARD COURSE
                    </button>
                    <button
                      className={`intensive-button ${
                        sessionType === "intensive" ? "active-session" : ""
                      }`}
                      onClick={() => handleSessionTypeChange("intensive")}
                    >
                      INTENSIVE COURSE
                    </button>
                  </div>

                  <div className="zx-layout-container">
                    <div className="zx-months-container">
                      {courseData.map((month, idx) => (
                        <button
                          key={idx}
                          className={`zx-month-button ${
                            activeMonth === idx ? "active" : ""
                          }`}
                          onClick={() => handleMonthClick(month.courses, idx)}
                        >
                          {month.month}
                        </button>
                      ))}
                    </div>

                    <div className="zx-month-courses">
                      {selectedMonthCourses.length > 0 ? (
                        selectedMonthCourses.map((course, idx) => (
                          <div
                            key={idx}
                            className={`zx-course-details ${
                              activeCourse === course.id ? "active-course" : ""
                            }`}
                            onClick={() => handleCourseClick(course.id)}
                          >
                            <div className="zx-course-info">
                              <h3>
                                {course.Name}{" "}
                                <span
                                  className={`course-type ${
                                    course.master_course?.classroom_type ===
                                    "online"
                                      ? "online"
                                      : "classroom"
                                  }`}
                                >
                                  {course.master_course?.classroom_type ===
                                  "online"
                                    ? "online"
                                    : "classroom"}
                                </span>
                              </h3>
                              <p>
                                {new Date(course.date_start).toLocaleDateString()}{" "}
                                to{" "}
                                {new Date(course.date_end).toLocaleDateString()} (
                                {course.hours}h)
                              </p>
                            </div>
                            <div className="zx-course-buy">
                              <div className="time">
                                <span className="days">{course.days}</span>
                                <span className="time-range">
                                  {course.time_from} - {course.time_to}
                                </span>
                              </div>
                              <span className="price">{course.price} $</span>
                              <button className="buy-button">{data.lang === 'fr' ? 'Acheter' : 'Buy'}</button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No courses available</p>
                      )}
                    </div>
                  </div>
                </>
              </div>
            </div>
          // ))
        ) : (
          <p>No courses available</p>
        )}
      </>}
      {loading && <p>Loading courses...</p>}
    </div>
  );
};

export default Accordion;
